module.exports = __webpack_public_path__ + "772831ff633e4193b3f1047d650f889a.woff2";